// @ts-check
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchOptionTradeAction } from '../../../actions/optionTradeAction';
import FilterSection from '../FilterSection';
import FirstTable from '../FirstTable';
import OptionTradeFilterBar from '../OptionTradeFilterBar';

/**
 * @type {React.FC<import("../../../typings").TOptionTradeTableProps>}
 * @returns
 */

const OptionTradeTable = ({ pageState, setPageState }) => {
  const {
    currentDate,
    selectedGroupCallValue,
    selectedResultCallValue,
    toggleNoSpreads,
    toggleRemoveWeeks,
    toggleOnlyAtm,
  } = pageState;
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = () => {
      dispatch(fetchOptionTradeAction(pageState));
    };
    fetchData();
  }, [
    selectedGroupCallValue,
    selectedResultCallValue,
    toggleNoSpreads,
    toggleNoSpreads,
    toggleRemoveWeeks,
    toggleOnlyAtm,
    currentDate,
  ]);

  return (
    <div>
      <FilterSection pageState={pageState} setPageState={setPageState} />

      <OptionTradeFilterBar pageState={pageState} setPageState={setPageState} />
      <FirstTable
        table1Dropdown={pageState.toggleTable1Dropdown}
        date={currentDate}
      />
    </div>
  );
};

export default OptionTradeTable;



// WEBPACK FOOTER //
// ./src/Pages/HomePage/Tables/OptionTradeTable.jsx